module.exports = __webpack_public_path__ + "img/my.3562ac3a.svg";